export interface TemplateVariable {
  key: string
  label: string
}

export const CONFIRMATION_TEMPLATE_VARIABLES: TemplateVariable[] = [
  { key: '${firstName}', label: 'Имя для обращения' },
  { key: '${recipientName}', label: 'Полное имя покупателя' },
  { key: '${shipDate}', label: 'Дата отправки' },
  { key: '${shipTime}', label: 'Время передачи в СДЭК' },
  { key: '${region}', label: 'Регион покупателя' },
  { key: '${cdekNumber}', label: 'Трек-номер СДЭК' },
  { key: '${transitDays}', label: 'Дней в пути по плану СДЭК' },
  { key: '${deliveryDate}', label: 'Дата доставки по плану СДЭК' },
]

export const PRENOTIF_TEMPLATE_VARIABLES: TemplateVariable[] = [
  { key: '${firstName}', label: 'Имя для обращения' },
  { key: '${shipDate}', label: 'Дата отправки' },
]

export const COURIER_TEMPLATE_VARIABLES: TemplateVariable[] = [
  { key: '${firstName}', label: 'Имя для обращения' },
  { key: '${courierName}', label: 'Имя курьера' },
  { key: '${courierPhone}', label: 'Телефон курьера' },
  { key: '${courierCar}', label: 'Автомобиль курьера' },
  { key: '${courierPlate}', label: 'Госномер' },
  { key: '${cdekNumber}', label: 'Трек-номер СДЭК' },
  { key: '${confirmationCode}', label: 'Код получения из чата Маркета' },
]
